<script setup lang="ts">
import icons from "../../libs/formkit/icons";

const { name } = defineProps<{
    name: string
  }>()

const icon = computed(() => {
  return icons[name];
});
//TODO: refactor
</script>

<template>
  <span
    v-if="name"
    class="icon"
    v-html="icon"
  />
</template>


<style scoped>
.icon {
  display: inline-flex;
  width: 1em;
  height: 1em;
  line-height: 1;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
